module.exports = __webpack_public_path__ + "static/img/products application_normal2.571de781.jpg";